export class Perk {
  businessId: string;
  count: number;
  createdAt: Date;
  description: string;
  expirationDate: Date;
  id: string;
  image: string;
  legalDescription: string;
  name: string;
  productUrl: string;
  promoCode: string;
  updatedAt: Date;

  constructor(json: any) {
    this.businessId = json.belongsToBusiness;
    this.count = json.count || 0;
    this.createdAt = json.createdAt && new Date(json.createdAt);
    this.description = json.description;
    this.expirationDate = json.expirationDate && new Date(json.expirationDate);
    this.id = json.id || json._id;
    this.image = json.image;
    this.legalDescription = json.legalDescription;
    this.name = json.name;
    this.productUrl = json.productUrl;
    this.promoCode = json.promoCode;
    this.updatedAt = json.updatedAt && new Date(json.updatedAt);
  }
}
